import { ProjectDto } from '@/core';
import { useMemo } from 'react';
import { sort } from '@/utils';
import { useTranslation } from 'react-i18next';
import { TableTypesEnum } from '../../Projects.Constructor.Tables/hooks';

export const useTablesOptions = (projectData: ProjectDto) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });

  const mainTables = useMemo(
    () =>
      projectData.tables
        .filter((table) => table.type === TableTypesEnum.Main)
        .map((table) => ({ label: table.name, value: table.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData],
  );

  const summaryTables = useMemo(
    () =>
      projectData.tables
        .filter((table) => table.type === TableTypesEnum.Summary)
        .map((table) => ({ label: table.name, value: table.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData],
  );

  return useMemo(
    () => [
      { label: t('addSheets.mainTables'), options: mainTables },
      { label: t('addSheets.summaryTables'), options: summaryTables },
    ],
    [t, mainTables, summaryTables],
  );
};
